import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PdfUtils } from 'src/app/shared/utils/pdf-utils';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { take } from 'rxjs/operators';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import { ReportePresupuestoService } from 'src/app/services/reporte-presupuesto.service';

@Component({
  selector: 'modal-presupuestos-programas',
  templateUrl: './modal-presupuestos-programas.component.html',
  styleUrls: ['./modal-presupuestos-programas.component.scss']
})
export class ModalPresupuestosProgramasComponent implements OnInit {
  
  @ViewChild('modalPresupuestosProgramas')
  public modalPresupuestosProgramas: any;
  public modalActivo: NgbModalRef;

  constructor(private modalService: NgbModal,
    private pdfUtils: PdfUtils) { }

  ngOnInit() {
  }

  public  abrirlModalPresupuestos() {
    this.modalActivo = this.modalService.open(this.modalPresupuestosProgramas, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public descargarPDF(): void {
    this.pdfUtils.descargarPresupuestosProgramas();
  }

}
